var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBox = function SvgBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.25 11.96V5.04a.57.57 0 0 0-.288-.492L8.774 1.073a.55.55 0 0 0-.548 0L2.038 4.548a.57.57 0 0 0-.288.491v6.922a.57.57 0 0 0 .288.491l6.188 3.475a.55.55 0 0 0 .548 0l6.188-3.475a.57.57 0 0 0 .288-.491"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25 4.75 8.564 8.5 1.75 4.75M8.5 8.5V16"
  }))));
};
export default SvgBox;